<div class="p-4 sm:p-6 bg-gray-50 rounded-lg shadow-lg" *transloco="let t">
  <!-- Cabeçalho -->
  <div class="mb-4">
    <h1 class="text-2xl font-bold text-gray-800">{{ t('sellerOrders.title') }}</h1>
    <p class="text-sm text-gray-500">{{ t('sellerOrders.subtitle') }}</p>
  </div>

  <!-- Filtro de período -->
  <div class="bg-white p-4 rounded-lg shadow mb-4">
    <div class="flex flex-col sm:flex-row sm:items-end gap-4">
      <div class="flex-1">
        <label for="startDate" class="block text-sm font-medium text-gray-700">{{ t('sellerOrders.startDate') }}</label>
        <input type="date" id="startDate" name="startDate" [(ngModel)]="startDate" [max]="today"
          class="block w-full p-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500" />
      </div>

      <div class="flex-1">
        <label for="endDate" class="block text-sm font-medium text-gray-700">{{ t('sellerOrders.endDate') }}</label>
        <input type="date" id="endDate" name="endDate" [(ngModel)]="endDate" [max]="today"
          class="block w-full p-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500" />
      </div>

      <div class="flex-none">
        <button (click)="search()" [disabled]="loading"
          class="w-full sm:w-auto bg-blue-500 text-white px-6 py-2 rounded-md hover:bg-blue-600 transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed">
          <i class="fas fa-search mr-2"></i>{{ t('sellerOrders.search') }}
        </button>
      </div>
    </div>
    <p class="text-xs text-gray-500 mt-2">
      <i class="fas fa-info-circle mr-1"></i>{{ t('sellerOrders.rangeHint') }}
    </p>
  </div>

  <!-- Grade de pedidos -->
  <div class="overflow-x-auto bg-white p-4 sm:p-6 rounded-lg shadow-lg">
    <div class="flex items-center justify-between mb-4">
      <h2 class="text-lg font-semibold text-gray-700">{{ t('sellerOrders.total') }} {{ total }}</h2>
    </div>

    <!-- Carregando -->
    <div *ngIf="loading" class="flex items-center mb-4">
      <i class="fas fa-spinner fa-spin mr-2 text-gray-500"></i>
      <span class="text-gray-500">{{ t('sellerOrders.loading') }}</span>
    </div>

    <!-- Vazio -->
    <div *ngIf="!loading && orders.length === 0" class="text-center text-gray-500 py-10">
      <i class="fas fa-box-open text-3xl mb-2"></i>
      <p>{{ t('sellerOrders.empty') }}</p>
    </div>

    <!-- Tabela -->
    <table *ngIf="!loading && orders.length > 0" class="min-w-full table-auto divide-y divide-gray-200">
      <thead class="bg-gray-100">
        <tr>
          <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">{{ t('sellerOrders.col.orderId') }}</th>
          <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">{{ t('sellerOrders.col.date') }}</th>
          <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">{{ t('sellerOrders.col.buyer') }}</th>
          <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">{{ t('sellerOrders.col.product') }}</th>
          <th class="px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase">{{ t('sellerOrders.col.items') }}</th>
          <th class="px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase">{{ t('sellerOrders.col.quantity') }}</th>
          <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">{{ t('sellerOrders.col.status') }}</th>
          <th class="px-3 py-2 text-right text-xs font-medium text-gray-500 uppercase">{{ t('sellerOrders.col.total') }}</th>
        </tr>
      </thead>
      <tbody class="bg-white divide-y divide-gray-200">
        <tr *ngFor="let order of orders" class="hover:bg-gray-50">
          <td class="px-3 py-2 text-sm text-gray-700 whitespace-nowrap">{{ order.orderId }}</td>
          <td class="px-3 py-2 text-sm text-gray-700 whitespace-nowrap">{{ order.dateCreated | date: 'dd/MM/yyyy HH:mm' }}</td>
          <td class="px-3 py-2 text-sm text-gray-700">{{ order.buyerNickname || '-' }}</td>
          <td class="px-3 py-2 text-sm text-gray-700">
            <div class="truncate max-w-xs" [title]="order.firstItemTitle">{{ order.firstItemTitle || '-' }}</div>
            <span *ngIf="order.itemsCount > 1" class="text-xs text-gray-400">+{{ order.itemsCount - 1 }}</span>
          </td>
          <td class="px-3 py-2 text-sm text-gray-700 text-center">{{ order.itemsCount }}</td>
          <td class="px-3 py-2 text-sm text-gray-700 text-center">{{ order.totalQuantity }}</td>
          <td class="px-3 py-2 text-sm">
            <span class="inline-flex items-center px-2 py-1 rounded-md text-xs font-medium bg-gray-100 text-gray-700 ring-1 ring-gray-200">
              {{ order.status || '-' }}
            </span>
          </td>
          <td class="px-3 py-2 text-sm text-gray-700 text-right whitespace-nowrap">{{ formatCurrency(order.totalAmount) }}</td>
        </tr>
      </tbody>
    </table>

    <!-- Paginação -->
    <div *ngIf="!loading && total > limit" class="flex items-center justify-between mt-4">
      <button (click)="previousPage()" [disabled]="skip === 0"
        class="px-4 py-2 text-sm rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100 transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed">
        <i class="fas fa-chevron-left mr-1"></i>{{ t('sellerOrders.previous') }}
      </button>
      <span class="text-sm text-gray-600">{{ t('sellerOrders.page', { current: currentPage, total: totalPages }) }}</span>
      <button (click)="nextPage()" [disabled]="skip + limit >= total"
        class="px-4 py-2 text-sm rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100 transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed">
        {{ t('sellerOrders.next') }}<i class="fas fa-chevron-right ml-1"></i>
      </button>
    </div>
  </div>
</div>
